// Maps backend status to frontend stage index
export const getStageIndex = (status) => {
  switch (status) {
    case 'Pending':
      return 0;
    case 'Order Confirmed':
      return 1;
    case 'Preparing':
    case 'Processing':
    case 'processing':
    case 'proccessing':
      return 2;
    case 'Out for Delivery':
    case 'Ready for Pickup':
      return 3;
    case 'Delivered':
    case 'Picked Up':
      return 4;
    case 'Feedback':
      return 5;
    case 'Completed':
      return 6;
    default:
      return 0;
  }
};
